/**
 * https://github.com/tuax/tua-body-scroll-lock
 */
import { lock, unlock, clearBodyLocks, BSLOptions } from 'tua-body-scroll-lock';

/**
 * AbstractComponent
 */
export class AbstractScrollBlocker {
  /**
   * element
   */
  element: any;

  /**
   * options
   */
  options: BSLOptions = {
    useGlobalLockState: true
  };

  /**
   * constructor
   * @param element
   */
  constructor(element: any) {
    this.element = element;
  }

  /**
   * lock
   * @param options
   */
  lock(options?: BSLOptions) {
    lock(this.element, {...options, ...this.options});
  }

  /**
   * unlock
   * @param options
   */
  unlock(options?: BSLOptions) {
    unlock(this.element, {...options, ...this.options});
  }

  /**
   * reset
   * @param options
   */
  reset(options?: BSLOptions) {
    clearBodyLocks({...options, ...this.options});
  }
}
